import { Form } from "react-bootstrap";
import {useState} from "react";
import {Helmet} from "react-helmet";


function ContactPage({albert}) {
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [content, setContent] = useState("");
  const [sending, setSending] = useState(false);

  const handleSubmit = async () => {
    if (sending) return;
    setSending(true);
    try {
      const response = await fetch("/api/sendemail",  {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({email: email, subject: subject, content: content})});
      if (!response.ok) {
        throw new Error("bad request");
      }
      albert("הודעה נשלחה בהצלחה");
      setEmail("");
      setSubject("");
      setContent("");
    } catch (error) {
      albert("אירעה שגיאה בשליחת ההודעה, נסו שוב מאוחר יותר");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="contact-page">
        <Helmet>
                <title>משכנתא דאטה | צור קשר </title>
                <meta name="description" content="צור קשר או דווח על תקלה" />
            </Helmet>

        <div className="contact-card">
            <div className="contact-card-header">
                <i className="bi bi-envelope-paper"></i>
                <h2>צור קשר</h2>
                <p>נתקלתם בבעיה, יש לכם רעיון לתכונה חדשה, או סתם רוצים להגיד שלום? נשמח לשמוע מכם.</p>
            </div>

            <Form>
                <div className="loan-form-section">
                    <Form.Label htmlFor="email"><i className="bi bi-envelope"></i> כתובת דוא"ל</Form.Label>
                    <Form.Control
                        id="email"
                        type="email"
                        value={email} onChange={(e) => {setEmail(e.target.value)}}
                        placeholder="כתובת דואר אלקטרוני" />
                </div>
                <div className="loan-form-section">
                    <Form.Label htmlFor="subject"><i className="bi bi-chat-square-text"></i> נושא</Form.Label>
                    <Form.Control
                        id="subject"
                        type="text"
                        value={subject} onChange={(e) => {setSubject(e.target.value)}}
                        placeholder="נושא ההודעה" />
                </div>
                <div className="loan-form-section">
                    <Form.Label htmlFor="content"><i className="bi bi-pencil-square"></i> תוכן ההודעה</Form.Label>
                    <Form.Control
                        id="content"
                        as="textarea"
                        value={content} onChange={(e)=>{setContent(e.target.value)}}
                        placeholder="ספרו לנו במה נוכל לעזור..." rows={6} />
                </div>

                <button className="addnew contact-submit" type="button" onClick={handleSubmit} disabled={sending}>
                    <i className="bi bi-send"></i>
                    {sending ? "שולח..." : "שלח הודעה"}
                </button>
            </Form>
        </div>

        <a
            href="https://www.facebook.com/profile.php?id=61574257622616"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-facebook-link"
        >
            <i className="bi bi-facebook"></i>
            אנחנו זמינים גם בפייסבוק, מוזמנים לקפוץ להגיד שלום :)
        </a>
    </div>
  );
}

export default ContactPage;
